import useAlert from 'CustomHooks/useAlert';
import useAuth from 'CustomHooks/useAuth';
import useAfterRolesLoaded from 'CustomHooks/useAfterRolesLoaded';
import usePinAuth, {
  GateActivity,
  SecurityGrant,
  SecurityPlusKeys,
} from 'CustomHooks/usePinAuth';

const useProtectedAction = (typeGlobal?: SecurityPlusKeys) => {
  const { roleMap } = useAuth();

  const alert = useAlert();

  const { checkAuthentication, authenticate, isGated } = usePinAuth();

  // `what` described the action for the former public signatureLogs; these
  // actions are logged to the Security Plus activity log only (see usePinAuth).
  function protectedAction(
    role: 'waiter' | 'chefWaiter' | 'admin' | 'tablet' = 'waiter',
    what: string,
    action: (grant?: SecurityGrant) => any,
    type = typeGlobal,
    activity?: GateActivity
  ) {
    const handleAction = (_signature: string, grant?: SecurityGrant) => action(grant);

    // A PIN that is still valid is used like a freshly entered one: the
    // action keeps its PIN profile and does not fall back to the role check.
    if (checkAuthentication(type ?? 'none')) {
      authenticate(type ?? 'none', handleAction, undefined, activity);
      return;
    }

    if (roleMap[role]) {
      // Exempted admins still pass Security Plus, which logs the exemption.
      if (isGated(type ?? 'none')) {
        authenticate(type ?? 'none', handleAction, undefined, activity);
      } else {
        handleAction('');
      }
    } else {
      alert({
        title: 'Keine Berechtigung',
        description:
          'Um dies auszuführen müssen Sie mindestens Chef Kellner sein',
        onSubmit: () => {},
        submitLabel: 'Okay',
      });
    }
  }

  return useAfterRolesLoaded(protectedAction);
};

export default useProtectedAction;
